// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";

export const CommonSuperAppStyles = (config: DesignSystem) => ({
    mainSuperAppContainer: {
        "& .cwt-fast-button, input.cwt-fast-button, button.cwt-fast-button": {
            "border-radius": "20px",
            "background-color": "linear-gradient(87.44deg, #3D6CDC -5.38%, #625ABA 103.44%)",
            "font-weight": "600"
        },

        "& a:hover, .cwt-link:hover:not(.cwt-fast-button), .cwt-link.cwt-icon:hover": {
            "text-decoration": "none"
        },

        "& .cwt-switch": {
            "& input": {
                "&:checked + .cwt-switch-slider": {
                    background: "linear-gradient(82.21deg, #3D6CDC -1.34%, #625ABA 97.29%)"
                }
            }
        }
    },
    mainInSuperappModal: {
        "overflow-y": "auto",
        display: "flex",
        "align-items": "flex-start"
    }
});